// extracted by mini-css-extract-plugin
export default {"rightAlign":"UYJcLNdlNLvKOiOnaLpm","leftAlign":"xfphtyG3MUNJcj0iOo9r","info":"dMJZv70Wxvc2AaabAntA"};